import { useEffect, useState } from 'react'

import fetchCognitoToken from 'helpers/aws'

const useCognitoAuthToken = () => {
  const [authToken, setAuthToken] = useState<string | null>(null)
  const [isAuthTokenLoaded, setIsAuthTokenLoaded] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authToken = await fetchCognitoToken()

        if (authToken) {
          setAuthToken(authToken.toString())
        }
      } catch {
        setAuthToken(null)
      }

      setIsAuthTokenLoaded(true)
    }

    fetchData()
  }, [])

  return {
    authToken,
    isAuthTokenLoaded
  }
}

export default useCognitoAuthToken
